var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-textarea',{attrs:{"label":"Observações","solo-filled":"","auto-grow":"","readonly":""},model:{value:(_vm.customer.tbObservacao),callback:function ($$v) {_vm.$set(_vm.customer, "tbObservacao", $$v)},expression:"customer.tbObservacao"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }